export const UI_COMPONENT = {
  TEXTFIELD: 'Textfield',
  TEXT_AREA: 'TextArea',
  MULTIPLE_CHOICE: 'Multiple Choice',
  CHECKBOXES: 'Checkboxes',
  DROPDOWN: 'Dropdown',
  BUTTONS: 'Buttons',
  SLIDER: 'Slider',
  DATE: 'Date',
  TIME: 'Time',
  FILE_UPLOAD: 'File Upload',
};
